import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderTypes } from '../../../common/enums/enums';
import useOpenConfirmationDialog from '../hooks/useOpenConfirmationDialog';
import useStatusByOrder from '../hooks/useStatusByOrder';

export default function ActionsByOrder({ order }) {
  const { enableConfirmation, markAllAsApproved, markAllAsDeclined } =
    useStatusByOrder(order);
  const { openConfirmationDialog } = useOpenConfirmationDialog();

  const { t } = useTranslation('approvals');

  const showConfirm = order.orderType !== OrderTypes.WORK_ORDER;

  return (
    <Stack
      direction={{ xs: 'column-reverse', sm: 'row' }}
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      width="100%"
    >
      <Stack direction="row" gap={2} width={{ xs: '100%', sm: 'unset' }}>
        <Button
          variant="text"
          color="error"
          size="small"
          sx={{ width: { xs: '50%', sm: 'unset' } }}
          onClick={markAllAsDeclined}
        >
          {t('DeclineAll')}
        </Button>
        <Button
          variant="text"
          color="success"
          size="small"
          sx={{ width: { xs: '50%', sm: 'unset' } }}
          onClick={markAllAsApproved}
        >
          {t('ApproveAll')}
        </Button>
      </Stack>
      {showConfirm && (
        <Button
          variant="outlined"
          size="small"
          disabled={!enableConfirmation}
          onClick={() => openConfirmationDialog(order)}
          sx={{ width: { xs: '100%', sm: '200px' }, textWrap: 'nowrap' }}
        >
          {t('ConfirmApprovals')}
        </Button>
      )}
    </Stack>
  );
}
